import ReactionIndex from './ReactionIndex';
import ReactionCreate from './ReactionCreate';
import ReactionSettings from './ReactionSettings';
import ReactionSingle from './ReactionSingle';

export default function (app) {

    const settings = ReactionSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 24,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    ReactionIndex(app, settings);

    ReactionCreate(app, settings);

    ReactionSingle(app, settings);

}